import { generateQueryParamsForRazarPay } from "../utils/loadScript";
import postUrl from "../utils/postUrl";

const getMandatoryEnv = require("../utils/getMandatoryEnv");

const customError = "Something went wrong, Please try again later!";
const { donationServiceConfig, domainDonations } = getMandatoryEnv([
  "donationServiceConfig",
  "domainDonations",
]);
function createPaymentRequest(donation_data) {
  const {
    currency = "INR",
    name,
    email,
    address,
    city,
    country,
    state,
    postalCode,
    phone,
    citizenship,
    donation_id = "9",
    amount,
    paymentSuccessUrl,
    paymentFailureUrl,
    projects = [],
    packageInfo = "",
    identificationType = "",
    identificationNumber = "",
    memberId = "",
    meditation_place = null,
    srcmGroupCompleteName = null,
    meditation_place_others = null,
  } = donation_data;

  const newData = {
    userProfile: {
      userId: "",
      firstName: name,
      lastName: "",
      emailAddress: email,
      phoneNumber: phone,
      addressLine1: address,
      addressLine2: "",
      city,
      state: state || "",
      postalCode,
      country,
      memberId,
      taxId:
        identificationNumber && identificationType === "Pancard"
          ? identificationNumber
          : "",
      citizenshipCountry: citizenship,
      role: null,
    },
    lineItems: [
      {
        id: "",
        donationItem: {
          id: donation_id,
          name: "",
          description: "",
          region: "",
          currency: "",
          billingAccountName: "",
          isActive: false,
        },
        currency,
        amount,
        recurringStartDate: "",
        recurringFrequency: "",
      },
    ],
    currency: null,
    amount: null,
    description: null,
    clientSuccessRedirectUrl: paymentSuccessUrl,
    clientFailureRedirectUrl: paymentFailureUrl,
    clientId: "me",
    extras: {
      projects,
      identityType: identificationType,
      identityNumber: identificationNumber,
      packageDetail: packageInfo,
    },
  };

  if (meditation_place && meditation_place !== "Others") {
    newData.extras.meditationPlace = meditation_place;
    newData.extras.center = srcmGroupCompleteName;
  } else if (
    meditation_place &&
    meditation_place_others &&
    meditation_place === "Others"
  ) {
    newData.extras.meditationPlace = meditation_place_others;
    newData.extras.center = meditation_place_others;
  }
  // console.log("POST DATA", postdata);
  const { url } = donationServiceConfig;
  // ...postdata, // firstName, lastName, email, phone, amount, currency, purpose, address, city, state, country, postalCode, citizenship, memberId, taxid,
  return {
    url,
    method: "POST",
    data: newData,
  };
}

function submitDonationRequest(
  formData,
  setLoader,
  onSuccess,
  onFailure,
  conf
) {
  const YECCommonMSG = conf?.YEC?.[0]?.commonMsg;
  const { url, method, data } = createPaymentRequest(formData);
  setLoader(true);
  fetch(url, {
    method,
    headers: new Headers({ "Content-type": "application/json" }),
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (response.ok) {
        setLoader(false);
        // console.log(response);
        // Site Maintenance message / error message
        response.json().then((json) => {
          if (json.error && json.message) {
            let errorMsg = json.message;
            if (json.error === "RES-0001") {
              errorMsg = YECCommonMSG;
            }
            const failueUrl = new URL(data.clientFailureRedirectUrl);
            const queryParams = { status: "failure", message: errorMsg };
            failueUrl.search = new URLSearchParams(queryParams).toString();
            window.location.href = failueUrl;
            return;
          }
          // console.log(json.donation, "SDS");
          // the status was ok and there is a json body
          if (
            !!json &&
            !json.paymentGatewayUrl &&
            json.paymentGatewayRequestParamMap
          ) {
            const params = generateQueryParamsForRazarPay(json);
            window.location.href = `${domainDonations}/razorpay/${params}`;
          } else if (!!json && "paymentGatewayUrl" in json) {
            onSuccess(json);
            if (json.paymentGatewayRequestMethod === "POST") {
              postUrl(
                json.paymentGatewayUrl,
                json.paymentGatewayRequestParamMap,
                "post",
                "_top"
              );
            } else if (
              // Redirecting Payment gateway to respective PrevProd url by changing host
              json.donation.currency === "USD" &&
              json.paymentGatewayUrl.includes("authorized-dot-net")
            ) {
              const paymentGateway = new URL(json.paymentGatewayUrl);
              paymentGateway.host = window.location.host;
              window.location.href = paymentGateway;
            } else window.top.location.href = json.paymentGatewayUrl;
          } else if (!!json && "msg" in json) {
            throw new Error(json.msg);
          } else {
            throw new Error("Server Connection Error. Please try again!");
          }
        });
      } else {
        setLoader(false);
        /* return */
        if ("statusText" in response && !!response.statusText) {
          onFailure(`customErrorMessage: ${customError}`);
        }
      }
    })
    .catch(() => {
      setLoader(false);
      onFailure(`customErrorMessage: ${customError}`);
    });
}

export default submitDonationRequest;
